module.exports = __webpack_public_path__ + "img/Monte_Kope_91.b919264f.jpg";